
// Adapted from:
// https://github.com/playcanvas/engine/blob/18bdc36d108031beca3fbfab948feb911eea2159/src/framework/components/rigid-body/constants.js

// Copyright (c) 2011-2017 PlayCanvas Ltd.

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.

const CONSTANTS = {
  // types
  BODYTYPE_STATIC: 'Static',
  BODYTYPE_DYNAMIC: 'Dynamic',
  BODYTYPE_KINEMATIC: 'Kinematic',

  // Collision flags
  BODYFLAG_STATIC_OBJECT: 1,
  BODYFLAG_KINEMATIC_OBJECT: 2,
  BODYFLAG_NORESPONSE_OBJECT: 4,

  // Activation states
  BODYSTATE_ACTIVE_TAG: 1,
  BODYSTATE_ISLAND_SLEEPING: 2,
  BODYSTATE_WANTS_DEACTIVATION: 3,
  BODYSTATE_DISABLE_DEACTIVATION: 4,
  BODYSTATE_DISABLE_SIMULATION: 5,

  // groups
  BODYGROUP_NONE: 0,
  BODYGROUP_DEFAULT: 1,
  BODYGROUP_DYNAMIC: 1,
  BODYGROUP_STATIC: 2,
  BODYGROUP_KINEMATIC: 4,
  BODYGROUP_ENGINE_1: 8,
  BODYGROUP_TRIGGER: 16,
  BODYGROUP_ENGINE_2: 32,
  BODYGROUP_ENGINE_3: 64,
  BODYGROUP_USER_1: 128,
  BODYGROUP_USER_2: 256,
  BODYGROUP_USER_3: 512,
  BODYGROUP_USER_4: 1024,
  BODYGROUP_USER_5: 2048,
  BODYGROUP_USER_6: 4096,
  BODYGROUP_USER_7: 8192,
  BODYGROUP_USER_8: 16384,

  // masks
  BODYMASK_NONE: 0,
  BODYMASK_ALL: 65535,
  BODYMASK_STATIC: 2,
  BODYMASK_NOT_STATIC: 65535 ^ 2,
  BODYMASK_NOT_STATIC_KINEMATIC: 65535 ^ (2 | 4),
}

export default CONSTANTS;



// WEBPACK FOOTER //
// ./src/modules/utils/physicsConstants.js